// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const lucario: PokeData = {
  "id": 448,
  "name": "lucario",
  "height": 12,
  "weight": 540,
  "base_experience": 184,
  "types": [
    PokeType.FIGHTING,
    PokeType.STEEL
  ],
  "api_moves": [
    "swords-dance",
    "bite",
    "counter",
    "quick-attack",
    "screech",
    "reversal",
    "mach-punch",
    "foresight",
    "detect",
    "bone-rush",
    "metal-claw",
    "crunch",
    "extreme-speed",
    "rock-smash",
    "helping-hand",
    "meteor-mash",
    "metal-sound",
    "iron-defense",
    "bulk-up",
    "calm-mind",
    "feint",
    "close-combat",
    "me-first",
    "copycat",
    "force-palm",
    "aura-sphere",
    "dark-pulse",
    "dragon-pulse",
    "vacuum-wave",
    "nasty-plot",
    "bullet-punch",
    "quick-guard",
    "heal-pulse",
    "final-gambit",
    "work-up",
    "power-up-punch",
    "laser-focus",
    "life-dew"
  ],
  "moves": [
    "bite",
    "quick-attack",
    "metal-claw",
    "crunch",
    "rock-smash",
    "meteor-mash",
    "metal-sound",
    "bulk-up",
    "calm-mind",
    "close-combat",
    "dark-pulse",
    "dragon-pulse",
    "vacuum-wave"
  ],
  "evolution_chain": {
    "id": 232,
    "item": null,
    "species": [
      {
        "name": "riolu",
        "order": 467,
        "types": [
          PokeType.FIGHTING
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "lucario",
        "order": 468,
        "types": [
          PokeType.FIGHTING,
          PokeType.STEEL
        ],
        "evolves_from_species_id": 447,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": null,
            "item": null,
            "location": null,
            "min_happiness": 160,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "day",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 102,
    "speed": 131,
    "ability_power": 167
  },
  "stat_changes": [],
  "catch_rate": 45,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
